import React, { useState } from 'react'
import "./singleContent.css"
import {Badge} from "@material-ui/core"
import {img_300} from "../../components/config/config"
import ModalContent from '../ContentModal/Modal'

// single movie card
const SingleContent = ({movie, mediaType}) => {
  const [openModal, setOpenModal] = useState(false)
 
  const handleOpen = () => setOpenModal(true)
  const handleClose = () => setOpenModal(false)
  // console.log(movie.id)
  return (
    <div>
      {openModal && <ModalContent open={openModal} handleClose={handleClose} movieID={movie.id} mediaType={mediaType} />}
      <div className='movie-card' onClick={handleOpen}>
        <Badge className='rating-badge' badgeContent={movie.vote_average} color={movie.vote_average>6?"primary":"secondary"}></Badge>
        <div className="img-container">
          <img className='movie-img' src={`${img_300}/${movie.poster_path}` || ""} alt="" />
        </div>
        <div className="movie-info">
          <h2 className='title'>{movie.title || movie.name}</h2>
          <span className='type'>{movie.media_type === "movie" ? "Movie":"TV Series"}</span>
          <p className='date'>{movie.release_date || movie.first_air_date}</p>
        </div>
      </div>
    </div>
  )
}

export default SingleContent
